import React, { useState, useEffect } from "react";
import List from "./List";

export default function Index({ enterpriseId, enterpriseTeamId }) {
  return (
    <>
      <div className="top-header-info">
        <div className="row">
          <div className="col-md-12">
            <h2>VB Enrollment Portability Invoices</h2>
            <hr />
          </div>
        </div>
        <List />
      </div>
    </>
  );
}
